import { DashboardOverview } from "@/components/dashboard/dashboard-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/")({
	component: DashboardIndexComponent,
	head: () => ({
		meta: [
			{ title: pageTitle(m.dashboard_title()) },
			{
				name: "description",
				content: m.dashboard_subtitle(),
			},
		],
	}),
});

function DashboardIndexComponent() {
	return <DashboardOverview />;
}
